import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDHeadlineText,
  FDPaper, FDStack,
  FDTable,
  FDTableBody,
  FDTableCell,
  FDTableHead,
  FDTableRow,
} from '@facet-wealth/design';
import { isFieldVisible } from 'Components/UI/Meta/isFieldVisible';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';

export const metaOverrideSet = buildFacetDesignOverride()
  .override({ readonly: true, type: 'string' }, {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly);

export function DistributionHistory({ prompt, collection, setCollection }) {
  const distributions = useMemo(() => collection.resources().list(), [collection]);
  const fields = useMemo(() => distributions[0]?.meta()?.template()?.list()?.filter(field => isFieldVisible(distributions[0], field)), [distributions]);
  if (distributions.length === 0 || fields.length === 0) {
    return null;
  }
  return (
    <FDPaper padding={4} appearance="elevated">
      <FDStack spacing={2} direction="column">
        <FDHeadlineText size="sm" value={prompt} />
        <FDTable>
          <FDTableHead>
            <FDTableRow>
              {fields?.map(field => <FDTableCell key={field.attr('name')}>{field.attr('prompt')}</FDTableCell>)}
            </FDTableRow>
          </FDTableHead>
          <FDTableBody>
            {distributions?.map((distribution, i) => (
              <FDTableRow key={distribution.id()}>
                {fields?.map(field => (
                  <FDTableCell key={field.attr('name')}>
                    <MetaControl
                      resource={distribution}
                      attrName={field.attr('name')}
                      metaOverrideSet={metaOverrideSet}
                      onChange={val => {
                        distributions[i].attr(field.attr('name'), val);
                        collection.resources().replaceAtIndex(i, distributions[i]);
                        setCollection(collection);
                      }}
                    />
                  </FDTableCell>
                ))}
              </FDTableRow>
            ))}
          </FDTableBody>
        </FDTable>
      </FDStack>
    </FDPaper>
  );
}

DistributionHistory.propTypes = {
  prompt: PropTypes.string,
  collection: PropTypes.object,
  setCollection: PropTypes.func,
};
DistributionHistory.defaultProps = {
  prompt: PropTypes.string,
  collection: undefined,
  setCollection: () => {},
};
